import * as React from 'react';
import styles from './user-members-item-row.scss';

export interface UserMembersItemRowProps {
  isWarning?: boolean;
  isZebra?: boolean;
  treeDepthLevel?: number;
  isLoader?: boolean;
  children?: React.ReactNode;
}

export const UserMembersItemRow: React.FC<UserMembersItemRowProps> = ({ children, isWarning, isZebra, treeDepthLevel, isLoader }) =>
  <div className={`${styles.row} ${isZebra ? styles.zebra : ''} ${isLoader ? styles.isLoader : ''} ${isWarning ? styles.missingEmail : ''}`}
    style={{ paddingLeft: `calc(8px + 40px*${treeDepthLevel})` }}>
    {children}
  </div>;
